export const fakeUnsuggestResponse = ({ params })=>{
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                errorDescription: 'Failed to unsuggest user',
                success: false
            };
        }
    }
    return {
        success: true
    };
};
export const fakeResponse = (url)=>({ params })=>{
        switch(url){
            case 'watch/unsuggest':
                return fakeUnsuggestResponse({
                    params
                });
            default:
                return null;
        }
    };
